import Vue from 'vue';
import Pages from './Pages.vue'

export const base = {
  props: {
    list_perpage: {required: false},
  },
  data () {
    return {
      p: 1,
      perpage: 12,
      loading: false,
    };
  },
  components: {Pages},
  computed: {
    pages () {return (this.paginated ? this.paginated.length : 0);},
  }
};

export const list = {
  mixins: [base],
  computed: {
    paginated () {
      var pages = [];
      if (this.items) {
        for (let i = 0; i < this.items.length; i+= this.page_limit) {
          pages[pages.length] = this.items.slice(i, i + this.page_limit);
        }
      }
      return pages;
    },
    page_limit () {
      return this.list_perpage || this.perpage;
    },
    list () {
      var i = this.p - 1;
      i = Math.min(i, Math.max(0, this.paginated.length));
      return this.paginated[i];
    },
  }
};

//async: component should have "baseurl"
export const async = {
  mixins: [base],
  data () {
    return {
      countAll: undefined,
      paginated: null,
      reloadcount: 1,
      cancel: {},
      generate_items: a=>a, //noop
    };
  },
  asyncComputed: {
    list: {
      get () {
        this.loading = true;
        var i = this.p - 1;
        if (this.paginated !== null) {
          i = Math.min(i, Math.max(0, this.paginated.length));
          if (this.paginated[i] !== null) {
            this.loading = false;
            return new Promise(resolve => resolve(this.paginated[i]));
          }
        }
        var base = this.baseurl;
        if (base) {
          this.list = null;
          if (base.substring(-1) !== '?') {
            base = base + (base.indexOf('?') > -1 ? '&': '?');
          }
          return this.api
            .get(base + 'range=' + String(this.perpage * i) + ',' + String(this.perpage), this.cancel)
            .then(this.generate_items)
            .then((data) => {
              this.countAll = this.api.lastCount;
              //calculate pages
              if (this.paginated === null) {
                this.paginated = new Array(Math.ceil(this.countAll / this.perpage)).fill(null);
                i = Math.min(i, Math.max(0, this.paginated.length));
              }
              //fill page
              this.$set(this.paginated, i, data);
              this.loading = false;
              return this.paginated[i];
            })
          ;
        }
      },
      watch () {
        this.reloadcount;
        this.baseurl;
        this.perpage;
        this.paginated;
      }
    }
  },
  watch: {
    perpage (now, before) {
      if (before === null || now === before) {
        return;
      }
      if (
        this.countAll !== undefined &&
        this.paginated &&
        this.paginated.length &&
        this.paginated[0].length
      ) {
        var all = this.paginated[0].clone();
        for (let page of this.paginated) {
          if (!page) {
            break;
          }
          all.union(page);
        }
        var tmp = new Array(Math.ceil(this.countAll / this.perpage)).fill(null);
        for (let p = 0; p < tmp.length; p++) {
          let slice = all.slice(p*this.perpage, (p+1)*this.perpage);
          if (slice.length === this.perpage) {
            tmp[p] = slice;
          } else {
            break;
          }
        }
        this.paginated = tmp;
      } else {
        this.paginated = null;
      }
      this.p = 1;
      this.loading = true;
    },
    baseurl (now, before) {
      if (before === null || now === before) {
        return;
      }
      this.paginated = null;
      this.p = 1;
      this.loading = true;
    },
    reloadcount (now, before) {
      if (now === before) {
        return;
      }
      this.paginated = null;
      this.p = 1;
      this.loading = true;
    },
  },
  beforeDestroy () {
    if (this.cancel.function) {
      this.cancel.function();
    }
  },
};

export const withapptoken = {
  mixins: [async],
  data () {return {
    baseurl: null,
  }},
  methods: {
    computeurl () {
      return this.async(['apptoken', 'user'], ([apptoken, user]) => {
          this.baseurl = this.asynclisturl(apptoken, user);
        })
        .toast(false)
      ;
    },
  },
  computed: {
    asynclist () {
      //delay loading if apptoken ID is not yet known (needed for URL)
      if (this.baseurl !== null) {
        return this.list;  //defined in pagination mixin
      }
      this.computeurl();
    }
  },
  watch: {
    asynclisturl () {
      this.computeurl();
    }
  },
  mounted () {
    this.computeurl();
  },
};

export default {};  // For some reason it doesn't work without this ???


// WEBPACK FOOTER //
// ./src/helpers/mixins/pagination/index.js